import React from "react";
import { useTranslation } from "react-i18next";

export type FeatureItem = {
  id: string;
  icon: string;
};

// Use feature IDs instead of hardcoded text
const featureIds: FeatureItem[] = [
  { id: "aiSummarization", icon: "/landing/icon.svg" },
  { id: "realTimeTranscription", icon: "/landing/icon.svg" },
  { id: "aiConversation", icon: "/landing/icon.svg" },
  { id: "aiGeneratedNotes", icon: "/landing/icon.svg" },
  { id: "quizzes", icon: "/landing/icon.svg" },
  { id: "flashcards", icon: "/landing/icon.svg" },
  { id: "folderManagement", icon: "/landing/icon.svg" },
  { id: "customizablePrompts", icon: "/landing/icon.svg" },
  { id: "clearAudioRecording", icon: "/landing/icon.svg" },
  { id: "importFromMultipleSources", icon: "/landing/icon.svg" },
  { id: "multipleExportFeatures", icon: "/landing/icon.svg" },
  { id: "multilanguageSupport", icon: "/landing/icon.svg" },
  { id: "realTimeTranslation", icon: "/landing/icon.svg" },
  { id: "editableTranscripts", icon: "/landing/icon.svg" },
  { id: "imageToTextConversion", icon: "/landing/icon.svg" },
  { id: "imageToLatexConversion", icon: "/landing/icon.svg" },
  { id: "crossDeviceSync", icon: "/landing/icon.svg" },
  { id: "cloudBackup", icon: "/landing/icon.svg" },
];

const WhyYouwoAI: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full bg-gray-50">
      {/* Header */}
      <header className="py-6 px-4">
        <h1 className="text-4xl font-bold text-center">
          {t("features.title")}
        </h1>
      </header>
      {/* Main Content */}
      <main className="px-4 pb-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 justify-items-center">
          {featureIds.map((feature, index) => (
            <div
              key={index}
              className="w-56 h-56 bg-white shadow rounded-xl p-4 flex flex-col items-center justify-center text-center"
            >
              <div className="bg-cornflowerblue p-2 rounded-full mb-2 flex items-center justify-center">
                <img
                  src={feature.icon}
                  alt={
                    t(`features.items.${feature.id}.iconAlt`) ||
                    `${feature.id} icon`
                  }
                  className="h-6 w-6"
                  loading="lazy"
                />
              </div>
              <h2 className="text-base font-semibold mb-1">
                {t(`features.items.${feature.id}.title`)}
              </h2>
              <p className="text-xs text-gray-600">
                {t(`features.items.${feature.id}.text`)}
              </p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default WhyYouwoAI;
